import { ReactNode } from "react";
import styled from "styled-components";
import { PANEL_FOOTER_HEIGHT } from "../Panel.Parts";

// TEXT

// STYLES
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  min-height: 0;

  overflow: hidden;
  flex: 1;
  height: 100%;
`;

export const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-flow: column nowrap;
  height: 100%;
  flex: 1;
  min-height: 0;

  opacity: 0;
  visibility: hidden;

  [data-state="open"] & {
    opacity: 1;
    visibility: visible;

    transition:
      opacity 200ms ease 80ms,
      visibility 0ms linear 80ms;
  }

  [data-state="closed"] & {
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0ms,
      visibility 0ms;
  }
`;

export const PanelScrollBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem;
  padding-bottom: calc(1.5rem + ${PANEL_FOOTER_HEIGHT});
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// DATA

// TYPES
export type Props = {
  children: ReactNode;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
